import React from 'react';

const CommunityLogoWithLink = ( { className, communityData } ) => {
  const image = (
    <img
      className={`${className}__logoImg`}
      src={communityData?.logoUrl}
      alt={communityData?.website}
    />
  );

  const markup = communityData?.website
    ? (
      <a
        className={className}
        target="_blank"
        href={communityData.website}
      >
        {image}
      </a>
    )
    : (
      <div className={className}>
        {image}
      </div>
    );

  return markup;
};

export default CommunityLogoWithLink;
